export interface TableColumn {
  key: string;
  label: string;
  width: string;
}

export const getTableColumns = (t: any): TableColumn[] => [
  {
    key: "department",
    label: t("assessments.tableColumns.department"),
    width: "300px",
  },
  {
    key: "assessmentName",
    label: t("assessments.tableColumns.assessmentName"),
    width: "300px",
  },
  {
    key: "equipment",
    label: t("assessments.tableColumns.equipment"),
    width: "300px",
  },
  {
    key: "material",
    label: t("assessments.tableColumns.material"),
    width: "300px",
  },
  {
    key: "workDescription",
    label: t("assessments.tableColumns.workDescription"),
    width: "300px",
  },
  {
    key: "date",
    label: t("assessments.tableColumns.date"),
    width: "300px",
  },
  {
    key: "action",
    label: t("assessments.tableColumns.action"),
    width: "150px",
  },
  {
    key: "delete",
    label: "",
    width: "60px",
  },
];

export const getUploadedAssessmentsTableColumns = (t: any): TableColumn[] => [
  {
    key: "assessmentName",
    label: t("assessments.tableColumns.assessmentName"),
    width: "auto",
  },
  {
    key: "fileType",
    label: t("assessments.tableColumns.fileType"),
    width: "160px",
  },
  {
    key: "date",
    label: t("assessments.tableColumns.date"),
    width: "160px",
  },
  {
    key: "action",
    label: t("assessments.tableColumns.action"),
    width: "180px",
  },
  {
    key: "delete",
    label: "",
    width: "60px",
  },
];
